import { render, staticRenderFns } from "./ZarrMetadataTab.vue?vue&type=template&id=3dd5b363&"
import script from "./ZarrMetadataTab.vue?vue&type=script&lang=js&"
export * from "./ZarrMetadataTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports